import { useQuery } from 'react-query';
import { fetchBookingShopSetting } from '../../../modules/ECommerce/_redux/booking2/booking2CRUD';

export const useBooking2ShopSetting = shop => {
  return useQuery({
    queryKey: ['booking2ShopSetting', shop?._id],
    queryFn: async () => {
      try {
        const { data } = await fetchBookingShopSetting(shop._id);
        return data;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // If the error is a 404, return null
          return null;
        } else {
          // For other errors, rethrow the error to be handled by react-query
          throw error;
        }
      }
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!shop?.isBooking2,
    staleTime: 60000,
    retry: 1
  });
};
